var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { CommitteeIdentifier } from "../../authorization/structures.js";
import { Node } from "../relay.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
let CommitteeNode = class CommitteeNode extends TimestampedResource {
    id;
    identifier;
    text() {
        return this.identifier;
    }
    static init(init) {
        return this.createInstance().withValues(init);
    }
    getUniqueId() {
        return this.id.id;
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], CommitteeNode.prototype, "id", void 0);
__decorate([
    Field(() => CommitteeIdentifier, { nullable: false }),
    __metadata("design:type", String)
], CommitteeNode.prototype, "identifier", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], CommitteeNode.prototype, "text", null);
CommitteeNode = __decorate([
    ObjectType({ implements: [Node] })
], CommitteeNode);
export { CommitteeNode };
//# sourceMappingURL=Committee.js.map